(function () {
  'use strict';

  // ── Toast ────────────────────────────────────────────────────────────

  let toastEl = null;
  let toastTimer = null;

  function getToast() {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cart-2voor-toast';
      document.body.appendChild(toastEl);
    }
    return toastEl;
  }

  function showToast(savingsCents) {
    const toast = getToast();
    const amount = formatMoney(parseInt(savingsCents, 10));
    toast.textContent = '🎉 You save ' + amount + '!';
    toast.classList.add('is-visible');

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 4500);
  }

  // Minimal money formatter — mirrors Shopify's euro convention
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + amount;
  }

  // ── Size pre-selection ───────────────────────────────────────────────

  function syncSizes() {
    var upsell = document.querySelector('.cart-2voor-upsell');
    if (!upsell) return;

    var currentSize = upsell.dataset.currentSize;
    if (!currentSize) return;

    upsell.querySelectorAll('.cart-2voor-upsell__tile').forEach(function (tile) {
      var matched = false;
      tile.querySelectorAll('.cart-2voor-upsell__size-btn').forEach(function (btn) {
        var match = btn.textContent.trim() === currentSize && !btn.disabled;
        btn.classList.toggle('is-selected', match);
        if (match) matched = true;
      });
      if (!matched) {
        tile.querySelectorAll('.cart-2voor-upsell__size-btn').forEach(function (btn) {
          btn.classList.remove('is-selected');
        });
      }
    });
  }

  // ── Dot carousel ────────────────────────────────────────────────────

  function initDots() {
    var upsell = document.querySelector('.cart-2voor-upsell');
    if (!upsell) return;

    var scroll = upsell.querySelector('.cart-2voor-upsell__scroll');
    var grid   = upsell.querySelector('.cart-2voor-upsell__grid');
    var dots   = upsell.querySelectorAll('.cart-2voor-upsell__dot');
    if (!scroll || !dots.length) return;

    function getTiles() {
      return grid.querySelectorAll('.cart-2voor-upsell__tile');
    }

    function getInlinePadding() {
      return parseInt(getComputedStyle(scroll).paddingInlineStart, 10) || 0;
    }

    function getTileWidth() {
      var tiles = getTiles();
      if (tiles.length > 1) {
        var w = tiles[1].getBoundingClientRect().left - tiles[0].getBoundingClientRect().left;
        if (w > 0) return w;
      }
      var w2 = tiles[0] ? tiles[0].offsetWidth : 0;
      return w2 > 0 ? w2 + 20 : 160;
    }

    // Click a dot → scroll to that tile
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var tileWidth = getTileWidth();
        scroll.scrollTo({ left: i * tileWidth, behavior: 'smooth' });
      });
    });

    // Scroll → update active dot (debounced so snap settles first on iOS)
    var scrollTimer = null;
    function updateActiveDot() {
      var tileWidth = getTileWidth();
      var idx = tileWidth > 0 ? Math.round(scroll.scrollLeft / tileWidth) : 0;
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }
    scroll.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateActiveDot, 80);
    }, { passive: true });
  }

  // ── Add to cart ──────────────────────────────────────────────────────

  function addVariantToCart(variantId, upsell, addBtn) {
    addBtn.disabled = true;
    addBtn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        showToast(upsell.dataset.savings);
        document.dispatchEvent(
          new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true })
        );
      })
      .catch(function (err) {
        console.error('[2-voor upsell] add failed:', err);
        addBtn.disabled = false;
        addBtn.textContent = 'ADD';
      });
  }

  // ── Event delegation (survives cart drawer re-renders) ───────────────

  document.addEventListener('click', function (evt) {
    // Size button toggle
    var sizeBtn = evt.target.closest('.cart-2voor-upsell__size-btn');
    if (sizeBtn && !sizeBtn.disabled) {
      var tile = sizeBtn.closest('.cart-2voor-upsell__tile');
      tile.querySelectorAll('.cart-2voor-upsell__size-btn').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      sizeBtn.classList.add('is-selected');
      return;
    }

    // ADD button
    var addBtn = evt.target.closest('.cart-2voor-upsell__add-btn');
    if (!addBtn) return;

    var tile   = addBtn.closest('.cart-2voor-upsell__tile');
    var upsell = addBtn.closest('.cart-2voor-upsell');
    var selected = tile.querySelector('.cart-2voor-upsell__size-btn.is-selected');

    if (!selected) {
      var sizesRow = tile.querySelector('.cart-2voor-upsell__sizes');
      sizesRow.style.outline = '2px solid rgb(var(--sale-price-color, 200 0 0))';
      setTimeout(function () { sizesRow.style.outline = ''; }, 1200);
      return;
    }

    addVariantToCart(selected.dataset.variantId, upsell, addBtn);
  });

  // ── Init & re-init hooks ─────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    syncSizes();
    initDots();
  });

  document.addEventListener('on:line-item:change', function () {
    setTimeout(function () {
      syncSizes();
      initDots();
    }, 50);
  });

  document.addEventListener('dispatch:cart-drawer:refresh', function () {
    setTimeout(function () {
      syncSizes();
      initDots();
    }, 300);
  });

})();
